/**
 * Constants for TipTap editor and related components
 */

// Timing constants (in milliseconds)
export const SAVE_STATUS_DISPLAY_DURATION = 2000; // How long to show "Saved" badge
export const AUTO_SAVE_DEBOUNCE_MS = 2000; // Debounce time for auto-saving notes

// UI constants
export const EDITOR_MIN_HEIGHT = '200px'; // Minimum height for the editor
export const EDITOR_LOADING_HEIGHT = '200px'; // Height of loading placeholder

// Toast configuration constants
export const TOAST_POSITION = 'bottom-left' as const;
export const TOAST_IS_CLOSABLE = true;
export const TOAST_ERROR_DURATION = 5000; // Duration for error toasts in milliseconds

export enum EditorName {
  InSessionProviderNotes = 'in-session-provider-notes',
  PostSessionProviderNotes = 'post-session-provider-notes',
  PostSessionFollowUpMessage = 'post-session-follow-up-message',
  PostSessionCarePlan = 'post-session-care-plan',
  PostSessionChartingNote = 'post-session-charting-note',
  MealPlanDetail = 'meal-plan-detail',
  InSessionTemplateManagement = 'in-session-template-management',
  AccessCarePlanReview = 'access-care-plan-review',
}
